<div class="content-header">
  <div>
    <h1>Discounts Management</h1>
  </div>
  <div>
    @if (authStore.canEdit()) {
      <sdc-button
        variant="primary"
        [attr.data-cy]="'discount-create-button'"
        (onClick)="openModalCreate()">
        Create Discount Code
      </sdc-button>
    }
  </div>
</div>
@if (refreshing) {
  <div class="loading">
    <div class="text-container">
      <div>
        <span>Loading discount codes</span>
      </div>
      <div>
        <div class="dot-typing"></div>
      </div>
    </div>
  </div>
}
<gs-table [data]="data" [columns]="columns"></gs-table>
<p class="legend">
  Showing {{ data.length }} of {{ totalItemsInDb }} total Discount Codes
</p>
<div class="pagination-container">
  <app-pagination
    [currentPage]="currentPage"
    [totalItemsInDb]="totalItemsInDb"
    [itemsPerPage]="itemsPerPage"
    #pagination></app-pagination>
</div>
